import {CouponTypeEnum} from 'modules/coupons/types';
import weekDaySelect from 'modules/notifications/util/week-day-select';
import useProductDetails from 'modules/products/hooks/use-product-details';
import useUpdateSale from 'modules/products/hooks/use-update-sale';
import {
  PriceModeEnum,
  SaleProps,
  SaleTypeEnum,
  translatedSaleProps,
} from 'modules/products/types';
import productsKeys from 'modules/products/util/products-keys';
import React from 'react';
import {useParams} from 'react-router-dom';
import Edition from 'shared/layout/edition';
import useFormInputs from 'shared/migration-components/form/util';
import Loading from 'shared/migration-components/loading';

const EditSale: React.FC = () => {
  const {id, saleId} = useParams();
  const {
    getSwitch,
    getSelect,
    getDatePicker,
    getNumberInput,
    getPriceInput,
    getMultiSelect,
  } = useFormInputs<SaleProps>();
  const {data, isLoading} = useProductDetails(id!);

  const handleSubmit = (data: SaleProps) => {
    return {
      ...data,
      date: data.date
        ? data.date.includes('T')
          ? data.date
          : new Date(`${data.date}T23:59:59`).toISOString()
        : undefined,
    };
  };

  if (isLoading) return <Loading />;

  return (
    <Edition<SaleProps>
      onSubmit={() => useUpdateSale(saleId!)}
      defaultValues={{active: true}}
      detailsUrl={`/sales/${saleId}`}
      {...{handleSubmit}}
      inputs={[
        getSelect({
          name: 'valueType',
          data: [
            {label: 'Valor', value: 'value'},
            {label: 'Porcentagem', value: 'percentage'},
          ],
          gridColumn: 6,
        }),
        getNumberInput({
          name: 'value',
          gridColumn: 6,
          hidden: (row) => row.valueType !== CouponTypeEnum.percentage,
        }),
        getPriceInput({
          name: 'value',
          gridColumn: 6,
          hidden: (row) => row.valueType !== CouponTypeEnum.value,
        }),
        getSelect({
          name: 'sizeId',
          data: (data?.sizes ?? []).map((size) => ({
            label: size.name,
            value: size.id,
          })),
          isLoading,
          hidden: () => data.priceMode === PriceModeEnum.fixed,
        }),
        getSelect({
          name: 'type',
          data: [
            {label: 'Única', value: SaleTypeEnum.oneTime},
            {label: 'Recorrente', value: SaleTypeEnum.periodical},
          ],
          gridColumn: 6,
        }),
        getMultiSelect({
          name: 'days',
          data: weekDaySelect,
          hidden: (data) => data.type !== SaleTypeEnum.periodical,
          gridColumn: 6,
        }),
        getDatePicker({
          name: 'date',
          hidden: (data) => data.type !== SaleTypeEnum.oneTime,
          gridColumn: 6,
        }),
        getSwitch({
          name: 'onePerOrder',
          hidden: (data) => data.type !== SaleTypeEnum.oneTime,
        }),
        getSwitch({
          name: 'onePerCustomer',
          hidden: (data) => data.type !== SaleTypeEnum.oneTime,
        }),
        getNumberInput({
          name: 'numberOfProducts',
          hidden: (data) => data.type !== SaleTypeEnum.oneTime,
        }),
        getSwitch({
          name: 'active',
        }),
      ]}
      translationKey={translatedSaleProps}
      queryKey={productsKeys.saleDetails(id!, saleId!)}
    />
  );
};

export default EditSale;
